// extracted by mini-css-extract-plugin
export default {"message-container":"message_message-container__ViggL","error-message-box":"message_error-message-box__SJvTc","success-message-box":"message_success-message-box__9p-c2"};